import { render, staticRenderFns } from "./TaxIdentificationNumberInput.vue?vue&type=template&id=ba2b9ad0&"
import script from "./TaxIdentificationNumberInput.vue?vue&type=script&lang=ts&"
export * from "./TaxIdentificationNumberInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports